/* eslint-disable no-unsafe-negation */
/* eslint-disable no-fallthrough */
/* eslint-disable no-useless-escape */
/* eslint-disable no-useless-concat */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from "react";
import { useDispatch, useStore as useReduxStore } from "react-redux";
import { Outlet, useNavigate, useParams } from "react-router-dom";

import { editorActions } from "@store/editor";
import { fotActions } from "@store/fot";

import { CotFlow } from "imagica-corekit/dist/cases/cot/CotFlow";
import { useReactFlow } from "reactflow";
import func from "@uikit/func";
// 保证某些滚动样式
import "simplebar-react/dist/simplebar.min.css";
import useFocusNode from "@custom-hooks/useFocusNode";
import { DIRECTIONHANDLE, NEW_EDGE_REG } from "./constants";
import utilIndex from "./utils/index";
import useRunEdgeAddNodeToPreview from "@custom-hooks/useRunEdgeAddNodeToPreview";
import { logEvent } from "@uikit/service/amplitude";
import { HomeChildProvider } from "../../custom-hooks/HomeUsePluginRoot/childContainer";
import useHandleOtherTypeRun from "../../custom-hooks/useHandleOtherTypeRun";
import useSetNodeErrorTips from "../../custom-hooks/useSetNodeErrorTips";
import { getIt } from "../../uikit/getIt";
import useHomeUsePluginUtil from "../../uikit/hooks/useHomeUsePluginUtil";
import { CotInputBloc } from "./CotInput/CotInputBloc";
import { getAutomaticDisplayType } from "./util";

import { useHomeGeneralMethod } from "@custom-hooks/HomeUsePluginRoot/useHomeGeneralMethod";
import { PreviewAppProvider, usePreviewAppStore } from "@custom-hooks/HomeUsePluginRoot/usePreviewAppStore";
import useNewEdgeRun from "../../uikit/hooks/useNewEdgeRun";

import { useStore as useImagincStore } from "imagica-uikit/dist/hooks/useStore";

import { WebConfigStore } from "imagica-corekit/dist/cases/webconfig/WebConfigStore";
import { FlowManager } from "@uikit/flow/FlowManager";
import { createContainer } from "unstated-next";
import { useHomeInit } from "@uiview/views/ProjectCanvas/useHomeInit";
import { CreatorStoreMethods } from "@uikit/service/CreatorStoreMethods";
import { useHomePreviewMethods } from "@uiview/views/ProjectCanvas/useHomePreviewMethods";
import { useHomeServices } from "@uiview/views/ProjectCanvas/useHomeServices";
import { useHomeHandleFieldMethods } from "@uiview/views/ProjectCanvas/useHomeHandleFieldMethods";
import { HomeMethodsUtil } from "@uikit/util/_homeUtil";
import { distance, markerEnd, selectApiReg } from "@uiview/views/ProjectCanvas/homeConst";
import { useHomeCot } from "@uiview/views/ProjectCanvas/useHomeCot";
import { HomeRoot } from "@uiview/views/HomeRoot/HomeRoot";
import { initSDK } from "@uikit/service/birdEatsBugSDKInit";
import { HomeStore } from "imagica-corekit/dist/cases/store/HomeStore";
import { useHomeRun } from "@uiview/views/ProjectCanvas/useHomeRun";
import { useCotFlowV3 } from "@uikit/hooks/useCotFlowV3";
import useTakeProjectSnapshot from "@custom-hooks/useTakeProjectSnapshot";
import { useFitCanvas } from "@uikit/hooks/useFitCanvas";
import { isEmpty, uniqBy } from "lodash";
import { useHomeReactFlow } from "@custom-hooks/HomeUsePluginRoot/useHomeReactFlow";
import { getDefaultPreviewAppTypeList } from "@uiview/views/PreviewApp/const";
import { HomeUsePluginUtil } from "@uikit/util/HomeUsePluginUtil";
import { isBlank } from "imagica-corekit/dist/base/cutil/Extensions";
import { sleep } from "./util";
import { eventbus } from "imagica-corekit/dist/base/cutil/Eventbus";
import { CotMsg } from "imagica-corekit/dist/base/msg/CotMsg";
import InvalidShareAppTip from "@uiview/views/InvalidShareAppTip/InvalidShareAppTip";
import { creatorCotStore } from "@uiview/views/ProjectCanvas/store/CreatorCotStore";
import { projectPageStore } from "@uiview/views/ProjectCanvas/store/ProjectPageStore";
import { invalidShareAppTipStore } from "@uiview/views/ProjectCanvas/store/InvalidShareAppTipStore";
import { creatorRefStore } from "@uiview/views/ProjectCanvas/store/CreatorRefStore";
import { previewStore } from "@uiview/store/PreviewStore";
import { popupFeedbackStore } from "@uiview/views/ProjectCanvas/store/PopupFeedback";
import { projectRunStore } from "@uiview/views/ProjectCanvas/store/ProjectRunStore";
import { CreatorAISaasStore } from "@uiview/views/ProjectCanvas/store/CreatorAISassStore";
import { CreatorSaasAppStore } from "@uiview/views/ProjectCanvas/store/CreatorSaasAppStore";
import { HomeMethodsService } from "@uikit/service/HomeMethodsService";
import { DataRefUtil } from "@uikit/util/DataRefUtil";
import { CreatorNodesStore } from "@uiview/views/ProjectCanvas/store/CreatorNodesStore";
import { CanvasDataRef } from "@uikit/model/CanvasDataRef";
import { FotSaveService } from "@uikit/service/FotSaveService";
import { SaveTemplateService } from "@uikit/service/SaveTemplateService";
import { allPreDefinedFunctions } from "./nodeTypeComponents/nodeTypeDispose";
import { CreatorEdgesStore } from "@uiview/views/ProjectCanvas/store/CreatorEdgesStore";
import { FotSaveEvent } from "@uikit/service/FotSaveEvent";
import { CanvasEdgeUtil } from "@uikit/util/CanvasEdgeUtil";
import { FocusNodeUtil } from "@uikit/util/FocusNodeUtil";
import { CanvasLineUtil } from "@uikit/util/CanvasLineUtil";
import { WindowSizeManager } from "@uikit/manager/WindowSizeManager";
import { PreviewAppStore } from "@uiview/views/ProjectCanvas/store/PreviewAppStore";
import { ProjectNodeStore } from "@uikit/projectNode/ProjectNodeStore";

export const { Provider: InnerProvider, useContainer: useHomePlugin } = createContainer(props => {
  const cotFlow = getIt(CotFlow);
  const homeStore = getIt(HomeStore);
  const creatorAISassStore = getIt(CreatorAISaasStore);
  const creatorSaasAppStore = getIt(CreatorSaasAppStore);
  const homeMethods = getIt(HomeMethodsService);
  const creatorNodesStore = getIt(CreatorNodesStore);
  const creatorEdgesStore = getIt(CreatorEdgesStore);
  const previewAppStore = getIt(PreviewAppStore);
  const projectNodeStore = getIt(ProjectNodeStore);

  const canvasDataRef = getIt(CanvasDataRef);
  //======== home hook
  const homeGeneralMethod = useHomeGeneralMethod();
  const homeServices = useHomeServices();
  const homeHandleFieldMethods = useHomeHandleFieldMethods();
  const creatorStoreMethods = getIt(CreatorStoreMethods);
  const homePreviewMethods = useHomePreviewMethods();
  const homeCot = useHomeCot();

  const { zoomTo } = useHomeReactFlow();

  const webConfigState = useImagincStore(getIt(WebConfigStore)).value;
  const store = useReduxStore();
  const dispatch = useDispatch();
  const cotInputBloc = new CotInputBloc(webConfigState.cot.examples);

  const homeStoreState = useImagincStore(homeStore).value;
  const feature_tags = homeStoreState.featureTags;

  // FIXME:OPT:
  // const cotStore = useSelector(state => state.editor.cot);
  const cotStore = store.getState().editor.cot;
  const setCotStore = val => {
    dispatch(editorActions.setCot(val));
  };

  const setVariableList = val => {
    dispatch(fotActions.setVariableList(val));
  };

  const { handleUploadFileRun } = useHandleOtherTypeRun({
    getSourceOfTruthResults: homeServices.getSourceOfTruthResults,
    setEdgeLineParam: creatorStoreMethods.setEdgeLineParam,
  });

  const { focusLastNode } = useFocusNode();

  const { setNodeErrorTip } = useSetNodeErrorTips();

  // FIXME:nodesRef
  const nodesRef = useMemo(
    () => ({
      get current() {
        return creatorNodesStore.getNodes();
      },
    }),
    []
  );

  const { setCenter } = useReactFlow();
  const flowManager = FlowManager.use();

  const { firstRunAddNodeToPreview } = useRunEdgeAddNodeToPreview({
    handleInputField: homeHandleFieldMethods.handleInputField,
    setInputId: creatorAISassStore.setInputId,
  });

  const {
    clickAddNewNode,
    getAndSetQueryV3,
    setEdgeValueByWriterV3,
    handleCustomToGroup,
    // removeInputFeild,
    handleGroupToCustom,
    autoAddInputNodeByBluePrint,
    onNodesDeleteV3,
  } = useHomeUsePluginUtil({
    distance: distance,
    getEdgeGeneration: homeServices.getEdgeGeneration,
    handleUploadFileRun,
    setStartingPointInput,
    getSaasAction: homeMethods.getSaasAction,
    firstRunAddNodeToPreview,
  });

  const handleSaveService = getIt(FotSaveService);

  const { corekitRun } = useNewEdgeRun({
    getSaveData: handleSaveService.getSaveDataV3,
    handleCustomToGroup,
    errorClosure: () => {
      projectRunStore.setRunAllLoading(false);
    },
    handleGroupToCustom,
    handleSave: handleSaveService.handleSave,
  });
  const { addPreview } = usePreviewAppStore();

  // cot相关
  const { showFlowByGroupV3 } = useCotFlowV3({
    getAndSetQueryV3,
    setEdgeValueByWriterV3,
    setCenter,
    corekitRun,
    getSimpleNodeData: canvasDataRef.getSimpleNodeDataV3,
  });

  const { takeProjectSnapshot } = useTakeProjectSnapshot({
    getHomeNodesIndex: creatorStoreMethods.getHomeNodesIndex,
    getHomeEdgesIndex: creatorStoreMethods.getHomeEdgesIndex,
    getSimpleNode: homeMethods.getSimpleNode,
    getSimpleEdge: homeMethods.getSimpleEdge,
    getFilterDataAttrsNode: HomeMethodsUtil.getFilterDataAttrsNode,
    getUIListParam: homeMethods.getUIListParam,
    getItemRelavantFunctions: creatorStoreMethods.getItemRelavantFunctions,
  });

  const { fitCanvas } = useFitCanvas();

  const defaultOpenWebApp = () => {
    // Cot 完成加载 默认打开 Web App
    // Cot Input 打开状态，不自动展开 Preview app
    if (creatorCotStore.state.showCot) return;
    const webData = [
      {
        label: "AI App",
        value: "saas",
        isStaticApp: false,
      },
    ];

    projectPageStore.setIsPublish(false);
    previewAppStore.setShowPreviewPanel(true);
    previewStore.setSelectedUI(webData[0].value);
  };
  const showEdges = async (edges, targetNode) => {
    const edge = edges[0];
    if (targetNode.data && !func.isEmpty(targetNode.data.identifier)) {
      // 后台接口返回了identifier
      const { identifier_type: type, identifier_value: value } = targetNode.data.identifier;
      creatorStoreMethods.setIdentifier(edge.id, { type, value });
      creatorEdgesStore.setQueryLoading(edge.id, "isGetQuery", true);
    } else if (selectApiReg.test(edge.data.lineParam.enterText) === false) {
      // function
      const { identifier } = await homeServices.getAndSetQuery(edge.id, edge.data.lineParam.enterText);
      creatorStoreMethods.setIdentifier(edge.id, identifier);
    } else {
      // 普通边
      creatorEdgesStore.setQueryLoading(edge.id, "isGetQuery", true);
    }
    await creatorStoreMethods.setEdgeValueByWriter(edge);
  };
  async function runSingleEdge(edgeId) {
    const edge = creatorEdgesStore.getEdges().find(x => x.id === edgeId);
    if (isEmpty(edge)) {
      return;
    }
    const node = nodesRef.current.find(x => x.id === edge.source);
    if (isEmpty(node)) {
      return;
    }
    const apiArr = [
      {
        sourceEdgeId: edge.id,
        sourceNodeId: edge.source,
        targetNodeId: edge.target,
        textAreaValue: node.data.textAreaValue,
        lineParam: edge.data.lineParam,
      },
    ];
    await homeServices.groupPostApi(apiArr, (target, tempText) => {
      creatorNodesStore.setNodes(prevList => {
        return prevList.map(l => {
          if (l.id === target) {
            // 自动判定获取内容 displayType
            const displayType = getAutomaticDisplayType(l.data, tempText);
            return {
              ...l,
              data: {
                ...l.data,
                textAreaValue: tempText.trim(),
                displayType: displayType,
              },
            };
          }
          return l;
        });
      });
    });
    await creatorStoreMethods.setTargetNodeShowFeedback(edge.target); //show feedback buttons after edge is run
  }
  const loadingForRendering = async () => {
    const end = () => {
      dispatch(editorActions.setProcessingCOT(false));
      if (feature_tags.showCotUserFeedback) {
        takeProjectSnapshot(); // when the graph is generated, take a snapshot for internal COT evaluation
      }
      creatorCotStore.setCotAutomaticNode(false);
      // setTimeout(() => {
      //   fitCanvas();
      // }, 800);
      setTimeout(() => {
        eventbus.emit(new CotMsg());
        zoomTo(0.5, { duration: 500 });
      }, 800);
      setTimeout(async () => {
        // await clickRunAllBtn([sourceNode]);
        if (isEmpty(creatorRefStore.COTInputOutputNodes.current) === false) {
          defaultOpenWebApp();
          const platforms = ["saas"];

          // stud-2493 set input(preview)(clear)
          // Empty input and output first
          creatorSaasAppStore.setSaasUIData(prevData => {
            return {
              ...prevData,
              output: [],
              input: [],
            };
          });
          projectNodeStore.composeNodes(creatorNodesStore.getNodes(), creatorSaasAppStore.state.saasUIData);

          const { input, output } = creatorRefStore.COTInputOutputNodes.current;
          const uniqNodes = uniqBy(nodesRef.current, node => node.id);
          const inputNodes = uniqNodes.filter(node => input.map(item => `editor-${item}`).includes(node.id));
          const outPutNodes = uniqNodes.filter(node => output.map(item => `editor-${item}`).includes(node.id));
          const outPutGroupNodes = uniqNodes.filter(node => output.map(item => `group-${item}`).includes(node.id));

          const inputIds = store.getState().fot.inputId;
          const addInputs = inputNodes.map(x => x.id);
          const newInputId = [...inputIds, ...addInputs];
          creatorAISassStore.setInputId(newInputId);

          platforms.forEach(platform => {
            const needAddInput = inputNodes.filter(node =>
              (creatorSaasAppStore.state.saasUIData.input || []).every(input => input.id !== node.id)
            );
            needAddInput.forEach(input => {
              homeHandleFieldMethods.handleInputField(input, platform, creatorRefStore.cotDescription.current);
            });
            outPutNodes.forEach(node => homePreviewMethods.addIndividual(node, platform, true));
            outPutGroupNodes.forEach(node => homePreviewMethods.clickGroupToPreview(node, platform, true));
          });
          previewAppStore.openPreviewPage();
          previewAppStore.clearPreviewApp();
          addPreview({ format: getDefaultPreviewAppTypeList()[0] });
          popupFeedbackStore.setEnableCOTFeedbackPopup(true);
        }
      }, 300);
    };

    /**
     * TODO: 流程中的 `setCetner` 与节点和边的聚焦出现重复行为，需要优化
     * @see `useFocusNode`
     */
    const showNode = async i => {
      let timer = setTimeout(async () => {
        if (i > projectPageStore.state.saasEdgesStaging.length - 1) {
          clearTimeout(timer);
          end();
        }
        const current = projectPageStore.state.saasEdgesStaging[i];

        // 退出当前项目停止流程
        if (!creatorCotStore.state.cotAutomaticNode) return;
        if (current) {
          if (creatorRefStore.isNewEdgeRunRef.current) {
            current.node = HomeUsePluginUtil.setStockNodeLoading(current.node);
            // v3
            creatorEdgesStore.setEdges(prevList => [...prevList, ...current.edges]);
            creatorNodesStore.setNodes(prevList => [...prevList, current.node, current.edgeNode]);
            HomeUsePluginUtil.hanleNodeOverlapping({
              setNode: creatorNodesStore.setNodes,
              allNodes: creatorNodesStore.getNodes().filter(x => !NEW_EDGE_REG.test(x.id)),
              currentNode: current.node,
            });
            await showFlowByGroupV3(current);
            //运行后id有可能改变了, 重新获取最后一个node作为当前node
            const mainNode = creatorNodesStore
              .getNodes()
              .filter(node => !NEW_EDGE_REG.test(node.id) && isBlank(node.parentNode));
            const currentNodeNew = mainNode.last();
            HomeUsePluginUtil.hanleNodeOverlapping({
              setNode: creatorNodesStore.setNodes,
              allNodes: creatorNodesStore.getNodes().filter(x => !NEW_EDGE_REG.test(x.id)),
              currentNode: currentNodeNew,
            });
            await showNode(i + 1);
          } else {
            // v2
            creatorEdgesStore.setEdges(prevList => [...prevList, ...current.edges]);
            creatorNodesStore.setNodes(prevList => [...prevList, current.node]);

            setCenter(current.node.position.x - 200, current.node.position.y, { duration: 300, zoom: 1.2 });
            await showEdges(current.edges, current.node);
            await sleep(800);
            setCenter(current.node.position.x, current.node.position.y, { duration: 300, zoom: 1.2 });
            await runSingleEdge(current.edges[0].id);
            await sleep(800);
            await showNode(i + 1);
          }
        }
      }, 1000);
    };

    creatorCotStore.setCotAutomaticNode(true);
    await showNode(0);
    fitCanvas();
  };
  // 监听cot-input结束时候执行runall逻辑
  // FIXME:OPT: cot 执行逻辑在 homeuseplugin，这样会导致 cotStore 变化刷新整个 homeuseplugin
  useEffect(() => {
    // v2的情况下才走原来的逻辑生成剩下的flow
    if (cotStore.creating === false && cotStore.inputIds.length > 0 && creatorCotStore.state.cotAutomaticNode) {
      loadingForRendering();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cotStore.creating]);

  function clickAddBtn(direction, otherProps, setCenter, displayType) {
    if (creatorRefStore.canvasMovingLoadingRef.current) return;
    creatorRefStore.canvasMovingLoadingRef.current = true;

    const isStickie = displayType === "inputTextarea";
    let offsetDistance = !isStickie ? 370 : 270;
    offsetDistance += otherProps.width;
    const startPointValue = 300;
    let newAddEdge = {};
    if (creatorRefStore.isNewEdgeRunRef.current) {
      newAddEdge = CanvasEdgeUtil.createNewEdge(otherProps);
    }
    const newNodeId = `editor-${creatorRefStore.nodeIndexRef.current++}`;
    const needMoveNode = creatorNodesStore.getNodes().filter(x => !NEW_EDGE_REG.test(x.id));

    //获取最下方或者最右方的node位置
    const adjacentNodepPosition = utilIndex.getBottomOrRightPosition(needMoveNode, direction, offsetDistance, {
      x: otherProps.xPos,
      y: otherProps.yPos,
    });

    //  通过AIChat模板创建的chatInterface，需要show tooltip
    const isChatAiOfNode = otherProps.autoSelectFunc === "chatInterface" ? { showChatInterfaceTooltip: true } : {};
    const newNode = {
      id: newNodeId,
      type: "customNode",
      data: Object.assign(
        {},
        { ...canvasDataRef.nodeDataRef.current },
        { displayType: isStickie ? "inputTextarea" : "text" },
        { showFeedback: false },
        { ...isChatAiOfNode }
      ),
      position: {
        x: otherProps.xPos,
        y: otherProps.yPos,
      },
    };
    //新node按照已有的输出node位置调整
    if (direction === "left" || direction === "right") {
      newNode.position.y = adjacentNodepPosition;
    } else {
      newNode.position.x = adjacentNodepPosition;
    }

    // 计算中心点
    const sourceCenterPos = {
      width: otherProps.width,
      height: otherProps.height,
      position: {
        x: otherProps.xPos,
        y: otherProps.yPos,
      },
    };
    // 620 是动画完成后真实的位置
    const targetCenterPos = {
      width: otherProps.width,
      height: otherProps.height,
      position: {
        x: newNode.position.x + 620,
        y: newNode.position.y,
      },
    };
    const centerData = FocusNodeUtil.focusPosition(sourceCenterPos, targetCenterPos, creatorNodesStore.state.nodes);
    // 创建边时边伸出的动画和边居中的动画需要同时进行
    if (centerData) {
      // FIXME: 创建边伸出去的动画和边聚焦的动画坐标计算， x 有 52 左右的偏差, 导致两个动画都被执行
      flowManager
        .focus(centerData, {
          duration: 800,
          zoom: 1,
          // FIXME: clickAddBtn 可能被缓存，导致 setCenter 和 showPreviewPanel 状态无法更新
          setCenter,
          showPreviewPanel: previewStore.state.showPreviewPanel,
        })
        .finally(() => {
          creatorRefStore.canvasMovingLoadingRef.current = false;
        });
    } else {
      creatorRefStore.canvasMovingLoadingRef.current = false;
    }

    // 从300开始缓慢移动
    if (direction === "top") {
      newNode.position.y -= startPointValue;
    } else if (direction === "right") {
      newNode.position.x += startPointValue;
    } else if (direction === "bottom") {
      newNode.position.y += startPointValue;
    } else if (direction === "left") {
      newNode.position.x -= startPointValue;
    }

    if (creatorRefStore.isNewEdgeRunRef.current) {
      creatorNodesStore.handleUpdateTarget({
        newNode,
        edgeNode: newAddEdge,
      });
      const sourceLine = CanvasLineUtil.createNewLine({
        source: otherProps.id,
        target: newAddEdge.id,
        type: "source",
      });
      const targetLine = CanvasLineUtil.createNewLine({
        sourceNode: otherProps,
        source: newAddEdge.id,
        target: newNode.id,
        type: "target",
      });
      // 移动节点
      creatorStoreMethods.translateNode(newNode, direction, offsetDistance - startPointValue, 10);
      logEvent("create_edge");
      // 这里需要重新获取最新的node, 因为flows及id等数据存在更新
      const updatedNewNode = nodesRef.current.find(x => x.id === newNodeId);
      const updatedNewEdge = nodesRef.current.find(x => x.id === newAddEdge.id);
      creatorStoreMethods.onNodesEdgesAdd(
        [canvasDataRef.getSimpleNodeV3(updatedNewNode), canvasDataRef.getSimpleNodeV3(updatedNewEdge)],
        [
          DataRefUtil.getSimpleEdgeV3(sourceLine, canvasDataRef.newLineDataRef),
          DataRefUtil.getSimpleEdgeV3(targetLine, canvasDataRef.newLineDataRef),
        ]
      );
      return;
    }

    creatorNodesStore.setNodes(prev => {
      return [...prev, newNode];
    });

    // 新增连线
    /**
     * @type {import('../../base/util/CustomEdgeUtil').CustomEdgeType}
     */
    const newEdge = {
      id: `edge-${creatorRefStore.edgeIndexRef.current++}`,
      type: "customEdge",
      animated: false,
      source: otherProps.id,
      target: newNode.id,
      sourceHandle: DIRECTIONHANDLE[direction].source,
      targetHandle: DIRECTIONHANDLE[direction].target,
      markerEnd: markerEnd,
      data: {
        ...canvasDataRef.edgeDataRef.current,
        sourceHandle: DIRECTIONHANDLE[direction].source,
        targetHandle: DIRECTIONHANDLE[direction].target,
        // 添加边时的方向
        fromDirection: direction,
        lineParam: {
          ...canvasDataRef.edgeDataRef.current.lineParam,
          enterText: otherProps.enterText || "",
          queryValue: otherProps.queryValue || canvasDataRef.edgeDataRef.current.lineParam.queryValue,
        },
        isSliceAutoRun: otherProps?.isSliceAutoRun || false,
        selectedApi: otherProps?.selectedApi || {},
      },
    };
    creatorEdgesStore.setEdges(prevList => [...prevList, newEdge]);
    logEvent("create_edge");
    creatorStoreMethods.onNodesEdgesAdd([homeMethods.getSimpleNode(newNode)], [homeMethods.getSimpleEdge(newEdge)]);

    // 移动节点
    creatorStoreMethods.translateNode(newNode, direction, offsetDistance - startPointValue, 10);
  }

  function clickAddNodeBtn(e, data = {}) {
    const newNodeId = `editor-${creatorRefStore.nodeIndexRef.current++}`;
    homeMethods.saveSecondInputNodeId(newNodeId);
    const position = homeGeneralMethod.getNewNodePosition(e);
    const newNode = {
      id: newNodeId,
      type: "customNode",
      data: {
        ...canvasDataRef.nodeDataRef.current,
        ...data,
      },
      position: {
        x: position.x,
        y: position.y,
      },
    };

    creatorNodesStore.setNodes(prevList => {
      return [...prevList, newNode];
    });
    creatorStoreMethods.onNodesEdgesAdd([homeMethods.getSimpleNode(newNode)], []);
    // to avoid reversed event order received on amplitude because of 2 events are triggered in parallel
    setTimeout(() => {
      logEvent("create_node", data);
    }, 50);

    // 有 todotip 的节点移动视口到合适的位置
    if (data.isEnableTooltipNode) {
      setTimeout(() => {
        // 居中节点，但是需要减掉 todoTip 的高度
        focusLastNode({ height: -160 });
      }, 200);
    } else {
      // 聚焦节点
      setTimeout(() => {
        focusLastNode();
      }, 200);
    }

    return {
      nodeId: newNode.id,
    };
  }

  const addThink = async thinkValue => {
    if (func.isEmpty(thinkValue)) {
      func.customMsg({
        content: "Data cannot be empty.",
        type: "warning",
      });
      return;
    }
    homeMethods.emptyNodes();
    homeMethods.emptyPreviewApp();
    try {
      // setThinkLoading(true);
      /// STUD-1975 使用corekit里的cot解析方法
      const { inputs, previewData, extraSaasUIData, flowGroup } = await cotFlow.getTemplate(
        thinkValue,
        canvasDataRef.nodeDataRef.current,
        canvasDataRef.newEdgeDataRef.current,
        canvasDataRef.newLineDataRef.current
      );
      const saasInputNodeIds = inputs.map(node => node.id);
      creatorSaasAppStore.setSaasUIData(prev => ({
        ...prev,
        fromCotTitle: extraSaasUIData.title,
        fromCotSubtitle: extraSaasUIData.subTitle,
      }));

      setTimeout(() => {
        creatorRefStore.COTInputOutputNodes.current = previewData;
        creatorNodesStore.setNodes(inputs);
        projectPageStore.setSaasEdgesStaging(flowGroup);
        // setThinkLoading(false);
        if (typeof thinkValue === "string") {
          creatorRefStore.cotDescription.current = thinkValue;
        } else {
          const item = cotInputBloc.defaultOperationList.value.find(li => li.value === thinkValue?.option) || {};
          creatorRefStore.cotDescription.current = item?.label || "";
        }

        if (func.isEmpty(saasInputNodeIds)) {
          // util.messageUtil('Empty node');
          logEvent("empty_cot_result", previewData.templateValue);
          creatorCotStore.setShowUnsupported(true);
          return;
        }
        setTimeout(() => {
          setCotStore({
            creating: true,
            inputIds: saasInputNodeIds,
            currentInputId: saasInputNodeIds[0],
          });
          // bsf-1919 重置状态
          creatorCotStore.setCotAutomaticNode(true);
          homeCot.showAllInputs(saasInputNodeIds, inputs);
        }, 300);
      });
    } catch (error) {
      // setThinkLoading(false);
    }
  };

  function clickGroupAddBtn(direction, otherProps, setCenter, getZoom, displayType) {
    let Interval = 200;
    let widthDistance = 200;
    if (displayType === "text") {
      Interval = 250;
      widthDistance = 250;
    }
    const offsetDistance = 370 + otherProps.width;

    let newAddEdge = {};
    if (creatorRefStore.isNewEdgeRunRef.current) {
      newAddEdge = CanvasEdgeUtil.createNewEdge(otherProps);
    }

    const recentNodes = creatorNodesStore.getNodes();
    const currGroupNodes = recentNodes.filter(x => x.parentNode === otherProps.id);
    const newNodes = [];
    const childNode = [];
    const groupId = `group-${creatorRefStore.nodeIndexRef.current++}`;
    const needMoveNode = creatorNodesStore.getNodes().filter(x => !NEW_EDGE_REG.test(x.id));

    creatorRefStore.sliceLevelRef.current++;
    currGroupNodes.forEach((x, index) => {
      const newNodeId = `editor-${creatorRefStore.nodeIndexRef.current++}`;
      const newNode = {
        id: newNodeId,
        type: "customNode",
        parentNode: groupId,
        extent: "parent",
        data: {
          ...canvasDataRef.nodeDataRef.current,
          sliceLevel: creatorRefStore.sliceLevelRef.current,
          isSliceNode: true,
          parentNodeId: groupId,
          displayType: displayType,
        },
        position: {
          x: distance,
          y: distance * (index + 1) + index * Interval,
        },
      };
      newNodes.push(newNode);
      childNode.push(newNodeId);
    });
    // 新增group
    const groupHeight =
      currGroupNodes.length * Interval +
      ((currGroupNodes.length + 1) * distance) / 2 +
      projectPageStore.state.previewHeight;
    const getCenterY = otherProps.yPos + otherProps.offsetHeight / 2;

    //获取最下方或者最右方的node位置
    const adjacentNodepPosition = utilIndex.getBottomOrRightPosition(
      needMoveNode,
      direction,
      offsetDistance,
      { x: otherProps.xPos, y: otherProps.yPos },
      widthDistance + 2 * distance,
      groupHeight
    );

    const newGroupNode = {
      id: groupId,
      type: "customGroup",
      markerEnd,
      data: {
        ...canvasDataRef.groupDataRef.current,
        childNode,
      },
      style: {
        width: widthDistance + 2 * distance,
        height: groupHeight,
      },
      position: {
        x: otherProps.xPos + 100,
        y: getCenterY - groupHeight / 2,
      },
    };
    //新node按照已有的输出node位置调整
    if (direction === "left" || direction === "right") {
      newGroupNode.position.y = adjacentNodepPosition;
    } else {
      newGroupNode.position.x = adjacentNodepPosition;
    }

    if (direction === "right") {
      newGroupNode.position.x += 350;
    } else if (direction === "left") {
      newGroupNode.position.x -= 350;
    }

    //使输入框居中，zoom不变
    const positionX = (otherProps.xPos + newGroupNode.position.x) / 2 + 100;
    const positionY = (otherProps.yPos + newGroupNode.position.y) / 2 + groupHeight / 2;
    setCenter(positionX, positionY, { duration: 300, zoom: getZoom() });

    if (creatorRefStore.isNewEdgeRunRef.current) {
      creatorNodesStore.handleUpdateTarget({
        newNode: newGroupNode,
        edgeNode: newAddEdge,
      });
      creatorNodesStore.setNodes(prevList => {
        return [...prevList, ...newNodes];
      });

      const updatedNewEdge = nodesRef.current.find(x => x.id === newAddEdge.id);
      const sourceLine = CanvasLineUtil.createNewLine({
        source: otherProps.id,
        target: newAddEdge.id,
        type: "source",
      });

      const targetLine = CanvasLineUtil.createNewLine({
        sourceNode: otherProps,
        source: newAddEdge.id,
        target: newGroupNode.id,
        type: "target",
      });

      /// 移动节点
      creatorStoreMethods.translateNode(newGroupNode, direction, offsetDistance - 350, 30);
      const newSimpleNodes = newNodes.map(homeMethods.getSimpleNode);
      creatorStoreMethods.onNodesEdgesAdd(
        [newGroupNode, canvasDataRef.getSimpleNodeV3(updatedNewEdge), ...newSimpleNodes],
        [
          DataRefUtil.getSimpleEdgeV3(sourceLine, canvasDataRef.newLineDataRef),
          DataRefUtil.getSimpleEdgeV3(targetLine, canvasDataRef.newLineDataRef),
        ]
      );
      return;
    }

    newNodes.unshift(newGroupNode);
    creatorNodesStore.setNodes(prevList => {
      return [...prevList, ...newNodes];
    });

    const newEdge = {
      id: `edge-${creatorRefStore.edgeIndexRef.current++}`,
      type: "customEdge",
      source: otherProps.id,
      target: groupId,
      animated: false,
      markerEnd,
      sourceHandle: DIRECTIONHANDLE[direction].source,
      targetHandle: DIRECTIONHANDLE[direction].target,
      data: {
        ...canvasDataRef.edgeDataRef.current,
        sourceHandle: DIRECTIONHANDLE[direction].source,
        targetHandle: DIRECTIONHANDLE[direction].target,
      },
    };
    creatorEdgesStore.setEdges(prevList => [...prevList, newEdge]);
    const newSimpleNodes = newNodes.map(homeMethods.getSimpleNode);
    creatorStoreMethods.onNodesEdgesAdd(newSimpleNodes, [homeMethods.getSimpleEdge(newEdge)]);
    // 移动节点
    // 620 - 350 = 270
    creatorStoreMethods.translateNode(newGroupNode, direction, offsetDistance - 350, 30);
  }

  async function clickSliceBtn(id) {
    //使用corekit的run
    if (creatorRefStore.isNewEdgeRunRef.current) {
      const sourceNode = nodesRef.current.find(x => x.id === id);
      const prevNode = {
        id,
        xPos: sourceNode.position.x,
        yPos: sourceNode.position.y,
      };
      const { newEdge, sourceLine, targetLine } = clickAddNewNode({ direction: "right", prevNode, isStickie: false });
      creatorNodesStore.setNodes(prevList => {
        return prevList.map(x => {
          if (x.id === newEdge.id) {
            return {
              ...x,
              data: {
                ...x.data,
                isGetQuery: true,
                lineParam: {
                  ...x.data.lineParam,
                  enterText: "/Split Output",
                  description: "Split large content into smaller pieces.",
                },
              },
            };
          }
          return x;
        });
      });
      const updateParam = {
        edgeId: newEdge.id,
        type: "lineParam",
        lineParam: {
          enterText: "/Split Output",
          description: "Split large content into smaller pieces.",
        },
      };
      const { transformData } = await corekitRun({
        getSimpleNodeData: homeMethods.getSimpleNodeData,
        edgeId: newEdge.id,
        updateParam,
      });

      // undo/redo监听处理
      const updatedNewEdge = nodesRef.current.find(x => x.id === newEdge.id);
      const groupNodes = nodesRef.current
        .filter(x => transformData.some(y => y.id === x.id))
        .map(homeMethods.getSimpleNode);
      const updatedLines = creatorEdgesStore
        .getEdges()
        .filter(x => x.id === sourceLine.id || x.id === targetLine.id)
        .map(edge => {
          return DataRefUtil.getSimpleEdgeV3(edge, canvasDataRef.newLineDataRef);
        });
      creatorStoreMethods.onNodesEdgesAdd([...groupNodes, canvasDataRef.getSimpleNodeV3(updatedNewEdge)], updatedLines);
      firstRunAddNodeToPreview({ sourceNode, outputNode: groupNodes[0] });
      return;
    }
    const newNodeId = `editor-${creatorRefStore.nodeIndexRef.current++}`;
    const newEdgeId = `edge-${creatorRefStore.edgeIndexRef.current++}`;
    const offsetDistance = 600;

    try {
      let currentNode = nodesRef.current.find(x => x.id === id);
      if (func.isEmpty(currentNode)) return;
      const needMoveNode = creatorNodesStore.getNodes();
      //获取最下方或者最右方的node位置
      const adjacentNodepPosition = utilIndex.getBottomOrRightPosition(
        needMoveNode,
        "right",
        offsetDistance,
        currentNode.position
      );

      // 创建 node
      const newNode = {
        id: newNodeId,
        type: "customNode",
        data: {
          ...canvasDataRef.nodeDataRef.current,
        },
        position: {
          x: currentNode.position.x + 350,
          y: currentNode.position.y,
        },
      };
      //新node按照已有的输出node位置调整
      newNode.position.y = adjacentNodepPosition;

      creatorNodesStore.setNodes(prevList => [...prevList, newNode]);
      // 移动节点
      // 250 = 600 - 350
      creatorStoreMethods.translateNode(newNode, "right", 600 - 350, 30);

      // 创建边
      const newEdge = {
        id: newEdgeId,
        type: "customEdge",
        source: currentNode.id,
        target: newNodeId,
        animated: false,
        markerEnd,
        sourceHandle: "b",
        targetHandle: "a",
        data: {
          ...canvasDataRef.edgeDataRef.current,
          isGetQuery: true,
          lineParam: {
            ...canvasDataRef.edgeDataRef.current.lineParam,
            enterText: "/Split Output",
            loading: true,
          },
        },
      };
      creatorEdgesStore.setEdges(prevList => [...prevList, newEdge]);

      await homeServices.getOtherTypeData(newEdge, "splitOutput", currentNode.data.textAreaValue);
    } catch (error) {
      setNodeErrorTip(newNodeId, error);
    } finally {
      creatorStoreMethods.setEdgeLineParam({
        id: newEdgeId,
        loading: false,
      });
    }
  }

  async function setStartingPointInput(sourceNodes, variableName) {
    const variableList = store.getState().fot.variableList;
    if (variableList.some(x => x.name === variableName)) return;
    const obj = {
      name: variableName,
      node: {
        ...sourceNodes,
        data: JSON.parse(JSON.stringify(sourceNodes.data)), // 去掉函数引用
      },
    };
    setVariableList([...variableList, obj]);
  }

  /**
   * @type {import("@uiview/views/ProjectCanvas/useHomeRun").HomeRunProps}
   */
  const runProps = {
    getSaveDataV3: handleSaveService.getSaveDataV3,
    handleCustomToGroup,
    handleGroupToCustom,
    handleSave: handleSaveService.handleSave,
    handleInputField: homeHandleFieldMethods.handleInputField,
  };

  const homeRun = useHomeRun({
    runProps: runProps,
  });

  /**
   * FIXME: 兼容老版本的 homeuseplguin, 未来需要移除
   */
  const childContainer = {
    onEdgeContentChange: creatorStoreMethods.onEdgeContentChange,
    getSimpleNodeData: homeMethods.getSimpleNodeData,
    getSaveDataV3: handleSaveService.getSaveDataV3,
    handleCustomToGroup,
    getAndSetQueryV3,
    // fixme:opt: clickRunAllBtn
    clickRunAllBtn: homeRun.clickRunAllBtn,
    handleSave: handleSaveService.handleSave,
    handleHiddenNode: HomeMethodsUtil.handleHiddenNode,
    emptyPreviewApp: homeMethods.emptyPreviewApp,
    autoSelectTemplate: homeHandleFieldMethods.autoSelectTemplate,
    addToPreviewList: homePreviewMethods.addToPreviewList,
    resetStartNodeIds: homeHandleFieldMethods.resetStartNodeIds,
    getUIListParam: homeMethods.getUIListParam,
    handleGroupToCustom,
    handleInputField: homeHandleFieldMethods.handleInputField,
    clickAddNodeBtn,
    autoAddInputNodeByBluePrint,
    addThink,
    newLineDataRef: canvasDataRef.newLineDataRef,
    nodeDataRef: canvasDataRef.nodeDataRef,
    showAllInputs: homeCot.showAllInputs,
    clickAddBtn,
    clickSliceBtn,
    addOrRemoveInputFeild: homeHandleFieldMethods.addOrRemoveInputFeild,
    clickGroupAddBtn,
    firstRunAddNodeToPreview,
  };
  return {
    childContainer,

    /**
     * @type {any}
     */
    props: props,
    newLineDataRef: canvasDataRef.newLineDataRef,
    nodeDataRef: canvasDataRef.nodeDataRef,
    getSimpleNode: homeMethods.getSimpleNode,
    getSimpleEdge: homeMethods.getSimpleEdge,
    getSaveDataV3: handleSaveService.getSaveDataV3,
    handleCustomToGroup,
    handleGroupToCustom,
    handleSave: handleSaveService.handleSave,
    handleInputField: homeHandleFieldMethods.handleInputField,
    runProps,
    postAIDescription: homeServices.postAIDescription,
    addThink,
    onNodesDeleteV3,
    getAndSetQueryV3,
    clickAddNodeBtn,
    // fixme:opt: clickRunAllBtn
    clickRunAllBtn: homeRun.clickRunAllBtn,
    showAllInputs: homeCot.showAllInputs,
    corekitRun,
    cotInputBloc,
    defaultOpenWebApp,
    getAndSetQuery: homeServices.getAndSetQuery,
  };
});

/**
 *
 * @param {object} props
 * @param {object|undefined} props.page
 * @returns {import('react').ReactNode}
 */
function HomeUsePlugin(props) {
  const { childContainer } = useHomePlugin();
  const { handleInit } = useHomeInit();
  const invalidShareAppTipState = useImagincStore(invalidShareAppTipStore).value;
  const saveTemplateService = getIt(SaveTemplateService);

  const fotSaveService = getIt(FotSaveService);
  const fotSaveEvent = getIt(FotSaveEvent);
  const windowSizeManager = WindowSizeManager.use();

  useEffect(() => {
    func.disableScale();
    // init bird SDK
    try {
      initSDK();
    } catch (error) {
      console.error("init bird sdk failed", error.message);
    }

    handleInit();
    return () => {
      func.moveDisableScale();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const unloadWindowSize = windowSizeManager.init();
    //Logging Amplitude click events
    window.addEventListener("click", HomeMethodsUtil.handleClickAmplitude);
    return () => {
      window.removeEventListener("click", HomeMethodsUtil.handleClickAmplitude);
      unloadWindowSize();
    };
  }, []);

  // ===== 将ui层的东西添加到其他 class 里面
  // handleSaveService 用到的 urlParam.attrIndexer 需要在 /editor/:attrIndexer 路由下面才能获取
  // 所以没有放在 fot/index.js 中
  const navigate = useNavigate();
  const urlParam = useParams();
  useEffect(() => {
    saveTemplateService.setAllPreDefinedFunctions(allPreDefinedFunctions);
    fotSaveService.setUrlParam(urlParam);
    fotSaveEvent.setNavigate(navigate);
  });

  if (invalidShareAppTipState.showInvalidShareAppTip) {
    return <InvalidShareAppTip />;
  }

  return (
    <HomeChildProvider initialState={childContainer}>
      <HomeRoot />

      <Outlet />
    </HomeChildProvider>
  );
}

/**
 * homeuseplugin 优化版本
 *
 * 1. Provider 如果有修改则也需要复制一份,目前在当前分支没有这样做
 *
 * @param {*} props
 * @returns
 */
export function HomeUsePluginRootV2(props) {
  return (
    <PreviewAppProvider>
      <InnerProvider initialState={props}>
        <HomeUsePlugin {...props} />
      </InnerProvider>
    </PreviewAppProvider>
  );
}
// stud-2043
